/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Row,
    Col, NavLink,
} from "reactstrap";
import classnames from "classnames";
import {getCookie, validateEmail} from "tools/tools"
import {NavLink as NavLinkRRD} from "react-router-dom";
import InfoModal from "../../components/Modals/InfoModal";
import {useState} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";

const Login = () => {
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [registrationErrors, setRegistrationErrors] = useState(null);
    const [errorModalIsOpen, setErrorModalIsOpen] = useState(false);
    const [errors, setErrors] = useState({
        email: '',
        password: '',
    });
    const {t, i18n} = useTranslation();
    const validateForm = () => {
        let newErrors = {email: '', password: ''};
        if (!userName) {
            newErrors.email = 'User name is required';
        }
        // } else if (!validateEmail(email)) {
        //     newErrors.email = 'Invalid email address';
        // }
        if (!password) newErrors.password = 'Password is required';
        setErrors(newErrors);
        return Object.values(newErrors).every(error => !error);
    };

    const handleSubmit = async (e) => {
        console.log("test")
        e.preventDefault();
        if (validateForm()) {
            try {
                var bodyFormData = new FormData();
                bodyFormData.append('username', userName);
                bodyFormData.append('password', password);
                const response = await axios.post('/api/login/', bodyFormData, {
                    headers: {
                        'X-CSRFToken': getCookie('csrftoken'),
                        'Content-Type': 'multipart/form-data',
                    },
                    withCredentials: true,
                });
                console.log(response)
                window.location.replace("/cabinet/");

            } catch (error) {
                console.log(error)
                setRegistrationErrors(error.response.data['errors'])
                setErrorModalIsOpen(true)
            }
        }
    };

    const errorModalBody = () => {
        return registrationErrors == null || registrationErrors.length === 0 ? ('error') : (<ul>
            {registrationErrors.map((error, index) => (
                <li key={index}>
                    <a target="_blank" rel="noopener noreferrer">
                        {error}
                    </a>

                </li>
            ))}
        </ul>)
    }

    return (
        <>
            <InfoModal
                isOpen={errorModalIsOpen}
                modalTitle={'Errors occurred during login'}
                onRequestClose={() => setErrorModalIsOpen(false)}
                body={errorModalBody}
                contentLabel="Error modal">
            </InfoModal>
            <Col lg="5" md="7">
                <Card className="bg-secondary shadow border-0">
                    <CardBody className="px-lg-5 py-lg-5">
                        <div className="text-center text-muted mb-4">
                            <small>{t('SignIn')}</small>
                        </div>
                        <Form role="form" onSubmit={handleSubmit}>
                            <FormGroup className="mb-3">
                                <InputGroup className="input-group-alternative">
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>
                                            <i className="ni ni-email-83"/>
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    <Input
                                        placeholder={t('UserName')}
                                        type="text"
                                        autoComplete="new-email"
                                        value={userName}
                                        onChange={(e) => {
                                            setUserName(e.target.value);
                                            setErrors({...errors, username: ''});
                                        }}
                                    />
                                </InputGroup>
                                {errors.email && <div className="text-danger">{errors.email}</div>}
                            </FormGroup>
                            <FormGroup>
                                <InputGroup className="input-group-alternative">
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>
                                            <i className="ni ni-lock-circle-open"/>
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    <Input
                                        placeholder={t('Password')}
                                        type="password"
                                        autoComplete="new-password"
                                        value={password}
                                        onChange={(e) => {
                                            setPassword(e.target.value);
                                            setErrors({...errors, password: ''});
                                        }}
                                    />
                                </InputGroup>
                                {errors.password && <div className="text-danger">{errors.password}</div>}
                            </FormGroup>
                            <div className="custom-control custom-control-alternative custom-checkbox">
                                <input
                                    className="custom-control-input"
                                    id=" customCheckLogin"
                                    type="checkbox"
                                />
                                <label
                                    className="custom-control-label"
                                    htmlFor=" customCheckLogin"
                                >
                                    <span className="text-muted">{t('RememberMe')}</span>
                                </label>
                            </div>
                            <div className="text-center">
                                <Button className="my-4" color="primary" type="submit">
                                    {t('login')}
                                </Button>
                            </div>
                        </Form>
                    </CardBody>
                </Card>
                <Row className="mt-3">
                    <Col xs="6">
                        <NavLink
                            className="text-light"
                            tag={NavLinkRRD}
                            to={"/test_react/auth/register"}
                        >
                            <small>{t('ForgotPassword')}</small>
                        </NavLink>
                    </Col>
                    <Col className="text-right" xs="6">
                        <NavLink
                            className="text-light"
                            tag={NavLinkRRD}
                            to={"/auth/register"}
                        >
                            <small>{t('CreateNewAccount')}</small>
                        </NavLink>
                    </Col>
                </Row>
            </Col>
        </>
    );
};

export default Login;
